import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-lista-clientes',
  templateUrl: './lista-clientes.component.html',
  styleUrls: ['./lista-clientes.component.css']
})
export class ListaClientesComponent implements OnInit {

  @Input() clientes!: any;
  @Input() clientesVinculadosAoAgrupamento = [] as any;
  @Output() enviaClientes = new EventEmitter();
  public paginaAtual = 1;
  filtrar = ''
  clientesTabela = [] as any
  clientesSelecionado = [] as any
  clientesDiferentes = [] as any
  constructor(private router: Router) { }

  ngOnInit(): void {
    this.clientesTabela = this.clientes
    this.clientesSelecionado = this.clientesVinculadosAoAgrupamento
    this.verificaClientesJaSelecionados()
  }

  filtrarUsuario() {
    this.paginaAtual = 1
    this.clientesTabela = this.clientes.filter((item: any) => item.vc_nome.toLowerCase().includes(this.filtrar.toLowerCase()));
  }

  selecionarCliente(cliente:any){
    let existe = this.clientesSelecionado.some((item: any) => {
      return item.sr_id == cliente.sr_id
    })
    if (!existe) {
      this.clientesSelecionado.push(cliente)
    }
    this.validaConfirmar()
  }

  enviarClientesSelecionados() {
    this.clientesSelecionado = this.clientesSelecionado.filter((element:any) => {
      return !this.clientesDiferentes.includes(element.sr_id)
    })
    this.enviaClientes.emit(this.clientesSelecionado);
  }

  removerCliente(index: any) {
    this.clientesSelecionado.splice(index, 1);
    this.validaConfirmar()
  }

  ngOnChanges() {
    this.clientesTabela = this.clientes
  }

  verificaClientesJaSelecionados(){
    const idClientesTabela = this.clientesTabela.map((element: any) => element.sr_id)
    this.clientesSelecionado.forEach((element:any) => {
      if (!idClientesTabela.includes(element.sr_id)){
        this.clientesDiferentes.push(element.sr_id)
      }
    });

  }

  validaConfirmar(){
    let existeClienteValido = this.clientesSelecionado.filter((element: any) => {
      return !this.clientesDiferentes.includes(element.sr_id)
    })
    return existeClienteValido.length == 0
  }

  cancel() {
    this.router.navigate(['configuracao/agrupamentos']);
  }
}
